import axios from 'axios';
import { serviceUrl } from '../../App';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const GetCloudProductionTracking = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `+product-tracking`);
};
export const AddCloudProductionTracking = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.post(
    GetBackendUrlForGlobalFunctions() + `+product-tracking/create`,
    obj,
    { headers }
  );
};
export const UpdateCloudProductionTracking = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.post(
    GetBackendUrlForGlobalFunctions() + `+product-tracking/edit`,
    obj,
    { headers }
  );
};
export const DeleteCloudProductionTracking = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `+product-tracking/delete`,
    obj,
    { headers }
  );
};
